var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 639 639",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 256 404 C 282 348 282 292 256 237 240 205 248 167 276 146 303 125 341 125 367 147 393 169 401 206 385 238 359 293 359 348 386 404 400 431 394 463 374 485 354 507 322 514 295 504 267 493 248 467 246 436 250 425 251 414 256 404 Z M 350 204 C 350 188 336 174 321 174 305 174 292 188 292 204 292 220 305 233 321 233 337 233 350 219 350 204 Z M 321 465 C 337 465 350 452 350 436 350 420 337 407 321 407 304 407 292 420 292 436 292 452 305 465 321 465 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 401 181 C 404 181 406 182 407 182 446 210 489 219 537 217 570 215 600 239 608 271 616 303 603 336 573 352 545 368 508 364 486 340 458 310 426 289 387 279 385 279 384 278 382 277 388 245 414 217 401 181 Z M 508 288 C 507 304 520 318 536 319 552 320 566 306 567 290 567 274 554 261 538 260 522 260 509 272 508 288 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 239 454 C 215 445 191 433 165 426 148 421 129 421 110 422 73 423 44 404 33 370 24 337 38 302 67 286 97 269 134 275 159 302 186 331 218 351 259 360 253 394 226 421 239 454 Z M 133 347 C 132 331 118 319 102 320 86 320 73 333 73 349 73 365 87 380 103 379 119 379 134 363 133 347 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.04b5502f4a6bbdc38bb686ca8cdbf123.svg";
export { ForwardRef as ReactComponent };